<template>
  <div>

    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="ads !== null && ads.length > 0" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>          
          <th scope="col" class="text-center" colspan="4">Advertising</th>
          <th scope="col" class="text-center" colspan="2">Progress</th>
          <th scope="col" rowspan="2">Error</th>
        </tr>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">Placement</th>
          <th scope="col">Status</th>
          <th scope="col" class="text-right">Current</th>
          <th scope="col" class="text-right">Max</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="ad in ads">
        <tr :key="ad.id">
          <td>{{ad.id}}</td>
          <td>{{ad.ctime | getMomentStr}}</td>
          <td>{{ad.placement | getEnumAdPlacementName}}</td>
          <td>{{ad.status | getEnumAdPlacementStatusName}}</td>

          <template v-if="progressUsed(ad)">
            <td class="text-right">{{ad.combo_current}}</td>
            <td class="text-right">{{ad.combo_max}}</td>
          </template>

          <template v-if="!progressUsed(ad)">
            <td colspan="2" class="text-center unused">
              {{progressStr(ad)}}
            </td>
          </template>

          <td>{{ad.error_msg}}</td>
        </tr>
        </template>
      </tbody>
    </table>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          В рекламном журнале хранится информация о просмотре рекламы.
        </p>
        <p>
          В рекламном журнале сообщение хранится 7 дней.
          (Сообщения, которые старше 7-и дней, автоматически удаляются.)
        </p>
        <p>
          В поле Placement показано место в игре, где игрок посмотрел рекламу.
          Например, если в поле Placement указано значение VictoryScreen, значит, игрок посмотрел рекламу после уровня на экрене победы.
          Если в поле Placemant указано AdChest, значит, игрок посмотрел рекламу в окне рекламного сундука.
        </p>
        <p>
          Поле Progress используется не во всех строках рекламного журнала.
          Это поле используется только для рекламного сундука
          (т.е. только в тех строках, где Placemant имеет значение AdChest).
        </p>
        <p>
          В поле Progress current показано, сколько раз игрок посмотрел рекламу в сундуке.
          В поле Progress max показано, сколько раз нужно посмотреть рекламу, чтобы получить награду.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import { getEnumAdPlacementName       } from '../autogen/bundle';
import { getEnumAdPlacementStatusName } from '../autogen/bundle';


const EnumAdPlacement_AdChest = 3;

export default {
  name: 'PlayerAds',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      ads: null,
    };
  },

  computed: {
    message() {
      if(this.ads !== null && this.ads.length === 0) {
        return 'Ads log is empty.';
      }
      return null;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/player/${this.playerId}/ads`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.ads = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    progressUsed(ad) {
      return ad.placement === EnumAdPlacement_AdChest;
    },

    progressStr(ad) {
      if(ad.combo_current === 0 && ad.combo_max === 0) {
        return '';
      }
      return `${ad.combo_current} / ${ad.combo_max}`
    },
  },

  filters: {
    getEnumAdPlacementName,
    getEnumAdPlacementStatusName,
  },
};
</script>

<style scoped>
.unused {
  /*background-color: #f8f9fa;*/
  background-color: #e9ecef;
}
</style>

